import { Badge, Button, Group, Text } from "@mantine/core";
import type { PanelFilters } from "./PanelFilterModal";

interface PanelActiveFiltersProps {
  filters: PanelFilters;
  onClear: () => void;
}

export function PanelActiveFilters({
  filters,
  onClear,
}: PanelActiveFiltersProps) {
  return (
    <Group gap="xs" wrap="wrap">
      <Text size="sm" c="dimmed">
        Active:
      </Text>
      {filters.status && (
        <Badge variant="light">
          {filters.status === "active" ? "Active" : "Inactive"}
        </Badge>
      )}
      {filters.workflowKind && (
        <Badge variant="light" color="violet">
          {filters.workflowKind === "tissue_cypher"
            ? "Tissue Cypher"
            : "Ordinary"}
        </Badge>
      )}
      <Button variant="subtle" size="compact-sm" onClick={onClear}>
        Clear all
      </Button>
    </Group>
  );
}
